<ngb-alert [type]="'danger'" [hidden]="!show" (closed)="close()">
  <b>Warning:</b>
  you will soon lose access to this dashboard due to non-payment. Please
  <a class="alert-link" href="/account/edit#tab-billing-info" target="_self">
    update your billing information</a
  >
  to avoid any disruption in service.
</ngb-alert>
